<template>
  <el-dialog
    title="余额操作"
    :visible="visible"
    width="520px"
    append-to-body
    :destroy-on-close="true"
    :lock-scroll="false"
    custom-class="ele-dialog-form"
    @update:visible="updateVisible">
    <el-form ref="form" :model="form" :rules="rules" label-width="90px" size="small">
      <el-form-item label="用户名">
        <el-input :value="form.username" disabled />
      </el-form-item>
      <el-form-item label="当前余额">
        <el-input :value="balanceLabel" disabled />
      </el-form-item>
      <el-form-item label="修改金额" prop="money">
        <el-input clearable maxlength="20" v-model.trim="form.money" placeholder="请输入" />
      </el-form-item>
      <el-form-item label="修改类型" prop="state">
        <el-radio-group v-model="form.state">
          <el-radio
            v-for="item in operateTypeOptions"
            :key="item.value"
            :label="item.value">
            {{ item.label }}
          </el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="修改原因" prop="remark">
        <el-input clearable maxlength="200" v-model.trim="form.remark" type="textarea" :rows="3" placeholder="请输入" />
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="updateVisible(false)">取消</el-button>
      <el-button type="primary" :loading="loading" @click="save">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { loadDictOptions } from '@/utils/dict';

export default {
  name: 'BalanceUserEdit',
  props: {
    visible: Boolean,
    data: Object,
    assetType: {
      type: String,
      default: 'fiat'
    }
  },
  data() {
    return {
      form: {
        id: 0,
        username: '',
        money: '',
        state: 1,
        remark: '',
        balance: 0,
        pay_out_order_sum: 0,
        currency_code: 'CNY'
      },
      rules: {
        state: [{ required: true, message: '请选择', trigger: 'change' }],
        money: [{ required: true, message: '请输入', trigger: 'blur' }],
        remark: [{ required: true, message: '请输入', trigger: 'blur' }]
      },
      loading: false,
      operateTypeOptions: []
    };
  },
  computed: {
    balanceLabel() {
      const pending = Number(this.form.pay_out_order_sum || 0);
      const balance = Number(this.form.balance || 0) - pending;
      return `${balance.toFixed(2)} ${this.form.currency_code || 'CNY'}`;
    }
  },
  created() {
    loadDictOptions('balance_operate_type', { numberValue: true })
      .then((list) => { this.operateTypeOptions = list || []; })
      .catch((e) => this.$message.error(e.message));
  },
  watch: {
    visible(val) {
      if (!val) {
        this.loading = false;
        return;
      }
      this.initForm();
    }
  },
  methods: {
    initForm() {
      const row = this.data || {};
      const fiat = row.fiat_balances || {};
      this.form = {
        id: row.id || 0,
        username: row.username || row.nickname || '',
        money: '',
        state: 1,
        remark: '',
        balance: fiat.balance != null ? fiat.balance : (row.balance || 0),
        pay_out_order_sum: row.pay_out_order_sum || 0,
        currency_code: fiat.code || row.currency_code || 'CNY'
      };
      this.$nextTick(() => {
        if (this.$refs.form) this.$refs.form.clearValidate();
      });
    },
    save() {
      this.$refs.form.validate((valid) => {
        if (!valid || this.loading) return;
        this.loading = true;
        this.$http
          .post('/User/operationBalance', {
            id: this.form.id,
            money: this.form.money,
            state: this.form.state,
            remark: this.form.remark,
            asset_type: this.assetType || 'fiat',
            currency_code: this.form.currency_code || 'CNY'
          })
          .then((res) => {
            this.loading = false;
            if (res.data.code === 0) {
              this.$message.success(res.data.msg);
              this.updateVisible(false);
              this.$emit('done');
              return;
            }
            this.$message.error(res.data.msg);
          })
          .catch((e) => {
            this.loading = false;
            this.$message.error(e.message);
          });
      });
    },
    updateVisible(value) {
      this.$emit('update:visible', value);
    }
  }
};
</script>
